import { gql, useQuery } from "@apollo/client";

const GetTeacherCoordinatorReviewsQuery = gql`
  query getTeacherCoordinatorReviews($teacherIds: [String!]!) {
    getTeacherCoordinatorReviews(teacherIds: $teacherIds) {
      id
      teacherId
      reviewedAtUtc
    }
  }
`;

export type TeacherCoordinatorReviewSummary = {
  id: string;
  teacherId: string;
  reviewedAtUtc: string;
};

export function useTeacherCoordinatorReviews(teacherIds: string[]) {
  const { data, loading, refetch } = useQuery(
    GetTeacherCoordinatorReviewsQuery,
    {
      variables: { teacherIds },
      skip: teacherIds.length === 0,
      fetchPolicy: "cache-and-network",
    },
  );

  const reviews: TeacherCoordinatorReviewSummary[] =
    data?.getTeacherCoordinatorReviews ?? [];

  // Map teacherId → review for quick lookup
  const reviewByTeacherId = new Map<string, TeacherCoordinatorReviewSummary>(
    reviews.map((r) => [r.teacherId, r]),
  );

  return { reviewByTeacherId, loading, refetch };
}
